"use strict";

import {IConfig} from "../config";

var extend = require("extend");
import _le from "./le";
var LE = null;

var leInited = false;

var buildLE = function (config: IConfig) {
    if (!leInited) {
        if (!config.logEntriesBrowserAppToken) {
            var emptyFunction = function () {};
            LE = {
                trace: emptyFunction,
                debug: emptyFunction,
                log: emptyFunction,
                info: emptyFunction,
                warn: emptyFunction,
                error: emptyFunction
            };
            console.log("Browser Logging is disabled!");
        }
        else {
            LE = _le;
            console.log("Browser logging enabled: " + config.logEntriesBrowserAppToken);
            LE.init({token: config.logEntriesBrowserAppToken,
                catchall: true,
                trace: true,
                page_info: "per-page",
                print: false
            });
        }
    }
    leInited = true;
};



export class LogSink {
    constructor(config: IConfig) {
        buildLE(config);
    }

    private _removeCommonProps(data: any) {
        var consoleData = extend(true, {}, data);
        delete consoleData.hostname;
        delete consoleData.level;
        delete consoleData._level;
        delete consoleData.requestId;
        delete consoleData.app;
        delete consoleData.userUniqueId;
        return consoleData;
    }

    trace(obj: any) {
        LE.log(obj);
    }

    debug(obj: any) {
        LE.log(obj);
    }

    info(obj: any) {
        LE.log(obj);
    }

    warn(obj: any) {
        LE.log(obj);
    }

    error(obj: any) {
        console.error(this._removeCommonProps(obj));
        LE.log(obj);
    }


    push(obj: any) {

        if (obj.level >= 50) {
            this.error(obj);
        }
        else if (obj.level >= 40) {
            this.warn(obj);
        }
        else if (obj.level >= 30) {
            this.info(obj);
        }
        else if (obj.level >= 20) {
            this.debug(obj);
        }
        else {
            this.trace(obj);
        }
    }
}
